import React from 'react'
import { observer } from 'mobx-react'

const CrossbreakChartSlot = ({ store, position }) => {
    const slide = store.activeSlide
    const question = slide.question.get(position)

    if (!question) return null

    const data = store.getChartDataForQuestion(`${question?.questionId}-crossbreak`, position)

    return (
        <div className="pp-chart-slot-container">
            <div className="pp-derived-slot">
                {question
                    ? store.getChart(
                        {
                            ...data,
                            title: '',
                            containerSize: { height: 400, width: 450 },
                            chartType: 'standardColumn',
                            surveyId: question.surveyId,
                            settings: question.settings,
                            kpiType: 'crossbreak',
                        },
                        data?.data,
                    )
                    : null}
            </div>
        </div>
    )
}

export default observer(CrossbreakChartSlot)
